import React, { useState } from "react";

//routing

//redux
import { connect } from "react-redux";

//action
import { login } from "../store/admin/action";

const LoginPage = (props) => {
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [error, setError] = useState({
    email: "",
    code: "",
  });
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!email || !code) {
      const error = {};

      if (!email) error.email = "Email is Required!";
      if (!code) error.code = "Authenticator code is required!";

      return setError({ ...error });
    }
    const data = {
      email,
      code,
    };
    props.login(data);
  };
  return (
    <>
      <div className="login-page back__style">
        <div class="container">
          <div class="row justify-content-md-center">
            <div class="col-md-12 col-lg-4">
              <div class="card login-box-container">
                <div class="card-body">
                  <div class="authent-logo mb-4">
                    <span class="text-danger h2">VibeLynk<br></br>Diamond Seller</span>
                  </div>
                  <div class="authent-text">
                    {/* <p>Welcome to Vivins-Live</p> */}
                    <p>
                      Enter your email address and current Google Authenticator code to access the Diamond Seller
                      panel.
                    </p>
                  </div>

                  <form autoComplete="off">
                    <div class="mb-3">
                      <div class="form-floating">
                        <input
                          type="email"
                          class="form-control"
                          id="floatingInput"
                          placeholder="name@example.com"
                          required
                          value={email}
                          onChange={(e) => {
                            setEmail(e.target.value);
                            if (!e.target.value) {
                              return setError({
                                ...error,
                                email: "Email is Required !",
                              });
                            } else {
                              return setError({
                                ...error,
                                email: "",
                              });
                            }
                          }}
                        />
                        <label for="floatingInput">Email address</label>
                      </div>
                      <div class="mt-2 ml-2 mb-3">
                        {error.email && (
                          <div class="pl-1 text-left pb-1">
                            <span className="text-red font-size-lg">
                              {error.email}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                    <div class="mb-3">
                      <div class="form-floating">
                        <input
                          type="text"
                          inputMode="numeric"
                          maxLength="6"
                          class="form-control"
                          id="floatingPassword"
                          placeholder="6-digit code"
                          value={code}
                          onChange={(e) => {
                            const value = e.target.value.replace(/\D/g, "").slice(0, 6);
                            setCode(value);
                            if (!e.target.value) {
                              return setError({
                                ...error,
                                code: "Authenticator code is required !",
                              });
                            } else {
                              return setError({
                                ...error,
                                code: "",
                              });
                            }
                          }}
                        />
                        <label for="floatingPassword">Authenticator code</label>
                      </div>
                      <div class="mt-2 ml-2 mb-3">
                        {error.code && (
                          <div class="pl-1 text-left pb-1">
                            <span className="text-red">{error.code}</span>
                          </div>
                        )}
                      </div>
                    </div>
                    <div class="d-grid">
                      <button
                        type="submit"
                        class="btn btn-danger m-b-xs"
                        onClick={handleSubmit}
                      >
                        Sign In
                      </button>
                    </div>
                  </form>
                  <div class="authent-reg">
                    <p>Lost access to your authenticator? Contact an administrator to reset enrollment.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default connect(null, { login })(LoginPage);
